import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { getInvitation } from "../../store/slices/organisationSlice";
import { invitationMessages, invitationQueryParam } from "../../constants";

// The invitation in the register link (see InviteUsers), checked with the server: { token, details, error, isChecking }.
// details is what it's for ({ organisationName, abn, firstName, email, userType }) and error why it can't be used.
// Without one in the link there's nothing to check.
export default function useInvitation() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const token = useMemo(() => new URLSearchParams(search).get(invitationQueryParam), [search]);
  // The answer for checked.token, so one for an earlier link is never used for the current one
  const [checked, setChecked] = useState({ token: null, details: null, error: "" });

  useEffect(() => {
    if (!token) return undefined;

    let isCurrent = true;

    dispatch(getInvitation(token))
      .unwrap()
      .then(({ data }) => {
        if (isCurrent) setChecked({ token, details: data, error: "" });
      })
      .catch((payload) => {
        const message = typeof payload?.message === "string" ? payload.message : invitationMessages.LINK_CHECK_FAILED;

        if (isCurrent) setChecked({ token, details: null, error: message });
      });

    return () => {
      isCurrent = false;
    };
  }, [dispatch, token]);

  const isAnswered = Boolean(token) && checked.token === token;

  return {
    token,
    details: isAnswered ? checked.details : null,
    error: isAnswered ? checked.error : "",
    isChecking: Boolean(token) && !isAnswered,
  };
}
